"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJsonRequest = exports.isFormURLencodedRequest = exports.isFormDataRequest = exports.getContentTypeFromHeaders = exports.buildHeaders = exports.buildQueryString = void 0;
const core_1 = require("../core");
const types_1 = require("../xhr/types");
const buildQueryString = (url, params) => {
    let _url = url;
    if (!_url) {
        // @ts-expect-error just for client != TS
        return;
    }
    const hasQueryParams = _url.indexOf('?') > 0;
    if (params) {
        // TODO: just for compatibility with old browsers, but it should use `new URLSearchParams(xhrOptions.params).toString();`
        const query = Object.keys(params)
            .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
            .join('&');
        if (query.length > 0) {
            let separator = '&';
            if (!hasQueryParams) {
                separator = '?';
            }
            _url = url + separator + query;
        }
    }
    // eslint-disable-next-line consistent-return
    return _url;
};
exports.buildQueryString = buildQueryString;
const buildHeaders = (headers) => {
    const _headers = headers || {};
    return (0, core_1.convertObjectKeysToLowerCase)(_headers);
};
exports.buildHeaders = buildHeaders;
const getContentTypeFromHeaders = (headers) => {
    const contentTypeKey = Object.keys(headers).find((header) => {
        return header.match(/Content-Type/i);
    });
    if (contentTypeKey) {
        return headers[contentTypeKey];
    }
    return undefined;
};
exports.getContentTypeFromHeaders = getContentTypeFromHeaders;
const isFormDataRequest = (headers) => {
    const contentType = (0, exports.getContentTypeFromHeaders)(headers);
    if (!contentType) {
        return false;
    }
    return contentType === types_1.MediaType.FORMDATA;
};
exports.isFormDataRequest = isFormDataRequest;
const isFormURLencodedRequest = (headers) => {
    const contentType = (0, exports.getContentTypeFromHeaders)(headers);
    if (!contentType) {
        return false;
    }
    return contentType === types_1.MediaType.FORMURLENCODED;
};
exports.isFormURLencodedRequest = isFormURLencodedRequest;
const isJsonRequest = (jsonRequest) => {
    let found = false;
    if (jsonRequest === null || jsonRequest === void 0 ? void 0 : jsonRequest.headers) {
        const contentTypeKey = Object.keys(jsonRequest.headers).find((header) => {
            return header.match(/Content-Type/i);
        });
        found = !!(contentTypeKey && jsonRequest.headers[contentTypeKey] === types_1.MediaType.JSON);
    }
    return found;
};
exports.isJsonRequest = isJsonRequest;
//# sourceMappingURL=utils.js.map